import * as Ariakit from '@ariakit/react'

export const useDropdownState = Ariakit.useMenuStore
